/* eslint-disable react/prop-types */
import React from 'react';
import { Button } from 'semantic-ui-react';
import IconChecked from 'Assets/images/check.svg';

const ChangePasswordSuccess = ({ onClose }) => {
  return (
    <div
      style={{
        textAlign: 'center',
        padding: '20px',
      }}>
      <img src={IconChecked} alt="icon" />
      <h3>Password Changed Successfully!</h3>
      <p>Please re-login with your new credentials</p>
      <Button primary onClick={onClose}>
        Back To Login
      </Button>
    </div>
  );
};

export default ChangePasswordSuccess;
